import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import  store from './redux/store/index';
import {Provider} from 'react-redux';
import AccessDetailsProvider from "providers/AccessDetailsProvider";
import {ErrorBoundary} from './common/Error404/ErrorBoundary';
import './fonts/NunitoSans-SemiBold.ttf';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      
    <ErrorBoundary>
    <AccessDetailsProvider> 
      <BrowserRouter>
      <App />
    </BrowserRouter>
    </AccessDetailsProvider>
    </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
